// extracted by mini-css-extract-plugin
module.exports = {"root":"Link_root__jWNrL"};